<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" titulo="Sorteos" style="flex: 1 0 100%" />
    <div slot="contenido">
      <div class="tarjetario">
        <SorteoFreidoraFinPromocion v-if="visibleFinSorteoFreidora" class="tarjeta" />
      </div>
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    visibleFinSorteoFreidora() {
     return this.$store.state.portfolio.visibleFinSorteoFreidoraAire;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../Menus/menus.scss";
</style>
